import { Component, Input } from '@angular/core';

@Component({
  selector: 'shared-profile-header',
  templateUrl: './profile-header.component.html',
  styleUrls: ['./profile-header.component.scss'],
  host: { class: 'profile-header' },
})
export class SharedProfileHeaderComponent {
  @Input() profileUrl?: any;
}
